/**
 * Home Dry Containers Detail Formatter.
 *
 * @param {*} value
 * @param {*} row
 *
 * @returns {String}
 */
window.healthCheckDetailFormatter = function(value, row) {
    let html = "";
    // Emerson
    if (row.resource === "Emerson") {
        html += healthCheckDetailEmerson(row);
    }
    // Emerson Pro Act Core API
    if (row.resource === "Emerson ProAct Core API") {
        html += healthCheckDetailEmersonProActCoreAPI(row);
    }
    // Identec (SOAP)
    if (row.resource === "Identec (SOAP)") {
        html += healthCheckDetailIdentec(row);
    }
    // Thermo King (REST)
    if (row.resource === "Thermo King (REST)") {
        html += healthCheckDetailThermoKingRest(row);
    }
    // Thermo King (SOAP)
    if (row.resource === "Thermo King (SOAP)") {
        html += healthCheckDetailThermoKingSoap(row);
    }
    // Traxens (REST)
    if (row.resource === "Traxens (REST)") {
        html += healthCheckDetailTraxens(row);
    }
    // Horizon
    if (row.resource === "Horizon") {
        html += healthCheckDetailHorizon(row);
    }
    // Marine Traffic
    if (row.resource === "Marine Traffic") {
        html += healthCheckDetailMarineTraffic(row);
    }
    // C sence Booking Feeds API (REST)
    if (row.resource === "C sence Booking Feeds API (REST)") {
        html += healthCheckDetailCsenceBookingFeedsApiRest(row);
    }
    // C sence Temperatures API (REST)
    if (row.resource === "C sence Temperatures API (REST)") {
        html += healthCheckDetailCsenceTemperaturesApiRest(row);
    }
    // C sence Energy API (REST)
    if (row.resource === "C sence Energy API (REST)") {
        html += healthCheckDetailCsenceEnergyApiRest(row);
    }
    return html;
}

/**
 * Health Check Detail Emerson.
 * @param {Object} row
 */
function healthCheckDetailEmerson(row) {
    let html = "";
    if (row.status === "OK") {
        html += '<div class="alert alert-info" role="alert">';
        html += '<p>'+__('Requests have been received in the past :hours hours.').replace(':hours', row.data.hours)+'</p>';
        html += '</div>';
    }
    if (row.status === "FAILED") {
        html += '<div class="alert alert-danger" role="alert">';
        html += '<p>'+__('An error has occurred.')+'</p>';
        html += '</div>';
    }
    if (row.status === "WARNING") {
        html += '<div class="alert alert-warning" role="alert">';
        html += '<p>'+__('No requests have been received in the past :hours hours.').replace(':hours', row.data.hours)+'</p>';
        html += '</div>';
    }
    if (row.data.last_request.created_at === null) {
        return "";
    }
    html += '<h4>'+__('Last Request')+'</h4>';
    html += '<table class="table table-hover table-striped text-nowrap">';
    html += '<thead>';
    html += '<tr>';
    html += '<td class="col-md-2">'+__('Created At')+'</td>';
    html += '<td class="col-md-2">'+__('IP-Address')+'</td>';
    html += '<td>'+__('Hostname')+'</td>';
    html += '<td>&nbsp;</td>';
    html += '</tr>';
    html += '</thead>';
    html += '<tbody>';
    html += '<tr>';
    html += '<td>'+row.data.last_request.created_at+'</td>';
    html += '<td>'+row.data.last_request.ip_address+'</td>';
    html += '<td>'+row.data.last_request.hostname+'</td>';
    if (row.data.last_request.error_description !== null) {
        html += '<td style="background-color: #F2D4CE !important; color: #AE432E !important">';
        html += row.data.last_request.error_description;
        html += '</td>';
    } else {
        html += '<td>&nbsp;</td>';
    }
    html += '</tr>';
    html += '</tbody>';
    html += '</table>';
    // Latest Request per Client
    if (row.data.clients === null) {
        return "";
    }
    html += '<h4>'+__('Latest Request per Client')+'</h4>';
    html += '<table class="table table-hover table-striped text-nowrap">';
    html += '<thead>';
    html += '<tr>';
    html += '<td class="col-md-1">'+__('Status')+'</td>';
    html += '<td class="col-md-2">'+__('Name')+'</td>';
    html += '<td class="col-md-2">'+__('Client ID')+'</td>';
    html += '<td class="col-md-2">'+__('Created At')+'</td>';
    html += '<td class="col-md-2">'+__('IP-Address')+'</td>';
    html += '<td>'+__('Hostname')+'</td>';
    html += '<td>&nbsp;</td>';
    html += '</tr>';
    html += '</thead>';
    html += '<tbody>';
    $.each(row.data.clients, function(k, v) {
        html += '<tr>';
        html += '<td>'+healthCheckStatusFormatter(v.status)+'</td>';
        html += '<td>'+v.name+'</td>';
        html += '<td>'+v.client_id+'</td>';
        html += '<td>'+(v.last_request !== null ? v.last_request.created_at : '-')+'</td>';
        html += '<td>'+(v.last_request !== null ? v.last_request.ip_address : '-')+'</td>';
        html += '<td>'+(v.last_request !== null ? v.last_request.hostname : '-')+'</td>';
        if (v.last_request !== null && v.last_request.error_description !== null && typeof v.last_request.error_description !== "undefined") {
            html += '<td style="background-color: #F2D4CE !important; color: #AE432E !important">';
            html += v.last_request.error_description;
            html += '</td>';
        } else {
            html += '<td>&nbsp;</td>';
        }
        html += '</tr>';
    });
    html += '</tbody>';
    html += '</table>';
    return html;
}

/**
 * Health Check Detail Emerson Pro Act Core API.
 * @param {Object} row
 */
function healthCheckDetailEmersonProActCoreAPI(row) {
    let html = "";
    if (row.status === "OK") {
        html += '<div class="alert alert-info" role="alert">';
        html += '<p>'+__('Requests have been sent in the past :hours hours.').replace(':hours', row.data.hours)+'</p>';
        html += '</div>';
    }
    if (row.status === "FAILED") {
        html += '<div class="alert alert-danger" role="alert">';
        html += '<p>'+__('An error has occurred.')+'</p>';
        html += '</div>';
    }
    if (row.status === "WARNING") {
        html += '<div class="alert alert-warning" role="alert">';
        html += '<p>'+__('No requests have been sent in the past :hours hours.').replace(':hours', row.data.hours)+'</p>';
        html += '</div>';
    }
    if (row.data.last_request.created_at === null) {
        return "";
    }
    html += '<h4>'+__('Last Request')+'</h4>';
    html += '<table class="table table-hover table-striped text-nowrap">';
    html += '<thead>';
    html += '<tr>';
    html += '<td class="col-md-2">'+__('Created At')+'</td>';
    html += '<td class="col-md-2">'+__('URL')+'</td>';
    html += '<td class="col-md-2">'+__('Method')+'</td>';
    html += '<td>'+__('Status Code')+'</td>';
    html += '</tr>';
    html += '</thead>';
    html += '<tbody>';
    html += '<tr>';
    html += '<td>'+row.data.last_request.created_at+'</td>';
    html += '<td>'+row.data.last_request.url+'</td>';
    html += '<td>'+row.data.last_request.method+'</td>';
    html += '<td>'+row.data.last_request.status_code+'</td>';
    html += '</tr>';
    html += '</tbody>';
    html += '</table>';
    return html;
}

/**
 * Health Check Detail Identec.
 * @param {Object} row
 */
function healthCheckDetailIdentec(row) {
    let html = "";
    if (row.status === "OK") {
        html += '<div class="alert alert-info" role="alert">';
        html += '<p>'+__('Requests have been received in the past :hours hours.').replace(':hours', row.data.hours)+'</p>';
        html += '</div>';
    }
    if (row.status === "FAILED") {
        html += '<div class="alert alert-danger" role="alert">';
        html += '<p>'+__('An error has occurred.')+'</p>';
        html += '</div>';
    }
    if (row.status === "WARNING") {
        html += '<div class="alert alert-warning" role="alert">';
        html += '<p>'+__('No requests have been received in the past :hours hours.').replace(':hours', row.data.hours)+'</p>';
        html += '</div>';
    }
    if (row.data.error_warning !== null && typeof row.data.error_warning !== "undefined") {
        html += '<div class="alert alert-warning" role="alert">';
        html += '<p>'+row.data.error_warning+'</p>';
        html += '</div>';
    }
    if (row.data.error_failed !== null && typeof row.data.error_failed !== "undefined") {
        html += '<div class="alert alert-danger" role="alert">';
        html += '<p>'+row.data.error_failed+'</p>';
        html += '</div>';
    }
    if (row.data.last_request.created_at === null) {
        return "";
    }
    html += '<h4>'+__('Last Request')+'</h4>';
    html += '<table class="table table-hover table-striped text-nowrap">';
    html += '<thead>';
    html += '<tr>';
    html += '<td class="col-md-2">'+__('Created At')+'</td>';
    html += '<td class="col-md-2">'+__('IP-Address')+'</td>';
    html += '<td>'+__('Hostname')+'</td>';
    html += '</tr>';
    html += '</thead>';
    html += '<tbody>';
    html += '<tr>';
    html += '<td>'+row.data.last_request.created_at+'</td>';
    html += '<td>'+row.data.last_request.ip_address+'</td>';
    html += '<td>'+row.data.last_request.hostname+'</td>';
    html += '</tr>';
    html += '</tbody>';
    html += '</table>';
    return html;
}

/**
 * Health Check Detail Thermo King (REST).
 * @param {Object} row
 */
function healthCheckDetailThermoKingRest(row)
{
    let html = "";
    if (row.status === "OK") {
        html += '<div class="alert alert-info" role="alert">';
        html += '<p>'+__('Requests have been sent in the past :hours hours.').replace(':hours', row.data.hours)+'</p>';
        html += '</div>';
    }
    if (row.status === "FAILED") {
        html += '<div class="alert alert-danger" role="alert">';
        html += '<p>'+__('An error has occurred.')+'</p>';
        html += '</div>';
    }
    if (row.status === "WARNING") {
        html += '<div class="alert alert-warning" role="alert">';
        html += '<p>'+__('No requests have been sent in the past :hours hours.').replace(':hours', row.data.hours)+'</p>';
        html += '</div>';
    }
    if (row.data.created_at === null) {
        return "";
    }
    html += '<h4>'+__('Last Request')+'</h4>';
    html += '<table class="table table-hover table-striped text-nowrap">';
    html += '<thead>';
    html += '<tr>';
    html += '<td class="col-md-2">'+__('Created At')+'</td>';
    html += '<td class="col-md-2">'+__('Request URI')+'</td>';
    html += '<td>'+__('Request Method')+'</td>';
    html += '</tr>';
    html += '</thead>';
    html += '<tbody>';
    html += '<tr>';
    html += '<td>'+row.data.last_request.created_at+'</td>';
    html += '<td>'+row.data.last_request.request_uri+'</td>';
    html += '<td>'+row.data.last_request.request_method+'</td>';
    html += '</tr>';
    html += '</tbody>';
    html += '</table>';
    return html;
}

/**
 * Health Check Detail Thermo King (SOAP).
 * @param {Object} row
 */
function healthCheckDetailThermoKingSoap(row)
{
    let html = "";
    if (row.status === "OK") {
        html += '<div class="alert alert-info" role="alert">';
        html += '<p>'+__('Requests have been sent in the past :hours hours.').replace(':hours', row.data.hours)+'</p>';
        html += '</div>';
    }
    if (row.status === "FAILED") {
        html += '<div class="alert alert-danger" role="alert">';
        html += '<p>'+__('An error has occurred.')+'</p>';
        html += '</div>';
    }
    if (row.status === "WARNING") {
        html += '<div class="alert alert-warning" role="alert">';
        html += '<p>'+__('No requests have been sent in the past :hours hours.').replace(':hours', row.data.hours)+'</p>';
        html += '</div>';
    }
    if (row.data.created_at === null) {
        return "";
    }
    html += '<h4>'+__('Last Request')+'</h4>';
    html += '<table class="table table-hover table-striped text-nowrap">';
    html += '<thead>';
    html += '<tr>';
    html += '<td class="col-md-2">'+__('Created At')+'</td>';
    html += '<td>'+__('Soap Function')+'</td>';
    html += '</tr>';
    html += '</thead>';
    html += '<tbody>';
    html += '<tr>';
    html += '<td>'+row.data.last_request.created_at+'</td>';
    html += '<td>'+row.data.last_request.soap_function+'</td>';
    html += '</tr>';
    html += '</tbody>';
    html += '</table>';
    return html;
}

/**
 * Health Check Detail Traxens.
 * @param {Object} row
 */
function healthCheckDetailTraxens(row) {
    let html = "";
    if (row.status === "OK") {
        html += '<div class="alert alert-info" role="alert">';
        html += '<p>'+__('Requests have been received in the past :hours hours.').replace(':hours', row.data.hours)+'</p>';
        html += '</div>';
    }
    if (row.status === "FAILED") {
        html += '<div class="alert alert-danger" role="alert">';
        html += '<p>'+__('An error has occurred.')+'</p>';
        html += '</div>';
    }
    if (row.status === "WARNING") {
        html += '<div class="alert alert-warning" role="alert">';
        html += '<p>'+__('No requests have been received in the past :hours hours.').replace(':hours', row.data.hours)+'</p>';
        html += '</div>';
    }
    if (row.data.created_at === null) {
        return "";
    }
    html += '<h4>'+__('Last Request')+'</h4>';
    html += '<table class="table table-hover table-striped text-nowrap">';
    html += '<thead>';
    html += '<tr>';
    html += '<td class="col-md-2">'+__('Created At')+'</td>';
    html += '<td class="col-md-2">'+__('IP-Address')+'</td>';
    html += '<td>'+__('Hostname')+'</td>';
    html += '<td>&nbsp;</td>';
    html += '</tr>';
    html += '</thead>';
    html += '<tbody>';
    html += '<tr>';
    html += '<td>'+row.data.last_request.created_at+'</td>';
    html += '<td>'+row.data.last_request.ip_address+'</td>';
    html += '<td>'+row.data.last_request.hostname+'</td>';
    if (row.data.last_request.error_description !== null) {
        html += '<td style="background-color: #F2D4CE !important; color: #AE432E !important">';
        html += row.data.last_request.error_description;
        html += '</td>';
    } else {
        html += '<td>&nbsp;</td>';
    }
    html += '</tr>';
    html += '</tbody>';
    html += '</table>';
    return html;
}

/**
 * Health Check Detail Horizon.
 * @param {Object} row
 */
function healthCheckDetailHorizon(row) {
    let html = "";
    if (row.status === "OK") {
        html += '<div class="alert alert-info" role="alert">';
        html += '<p>'+__('Queues are currently being processed.')+'</p>';
        html += '</div>';
    }
    if (row.status === "FAILED") {
        html += '<div class="alert alert-danger" role="alert">';
        html += '<p>'+__('No queue has been processed.')+'</p>';
        html += '</div>';
    }
    if (row.status === "WARNING") {
        html += '<div class="alert alert-warning" role="alert">';
        html += '<p>'+__('No queue has been processed.')+'</p>';
        html += '</div>';
    }
    if (row.data === null) {
        return "";
    }
    html += '<table class="table table-hover table-striped text-nowrap">';
    html += '<thead>';
    html += '<tr>';
    html += '<td class="col-md-1">'+__('Status')+'</td>';
    html += '<td class="col-md-2">'+__('Dashboard')+'</td>';
    html += '<td>&nbsp;</td>';
    html += '</tr>';
    html += '</thead>';
    html += '<tbody>';
    $.each(row.data, function(k, v) {
        html += '<tr>';
        html += '<td>'+healthCheckStatusFormatter(v.status)+'</td>';
        html += '<td>';
        switch (k) {
            case 'default':
                html += 'C sence Dashboard';
                break;
            case 'data':
                html += 'C sence Data Dashboard';
                break;
        }
        html += '</td>';
        html += '<td>';
        if (v.status === "OK") {
            html += '<p>'+__('Queues are currently being processed.')+'</p>';
        }
        if (v.status === "FAILED") {
            html += '<p>'+__('No queue has been processed in the past :minutes minutes.').replace(':minutes', v.minutes)+'</p>';
        }
        if (v.status === "WARNING") {
            html += '<p>'+__('No queue has been processed in the past :minutes minutes.').replace(':minutes', v.minutes)+'</p>';
        }
        html += '</td>';
        html += '</tr>';
    });
    html += '</tbody>';
    html += '</table>';
    return html;
}

/**
 * Health Check Detail Marine Traffic.
 * @param {Object} row
 */
function healthCheckDetailMarineTraffic(row)
{
    let html = "";
    if (row.status === "OK") {
        html += '<div class="alert alert-info" role="alert">';
        html += '<p>'+__('Requests are sent.')+'</p>';
        html += '</div>';
    }
    if (row.status === "FAILED") {
        html += '<div class="alert alert-danger" role="alert">';
        html += '<p>'+__('An error has occurred.')+'</p>';
        html += '</div>';
    }
    if (row.status === "WARNING") {
        html += '<div class="alert alert-warning" role="alert">';
        html += '<p>'+__('No requests were sent to one or more endpoints.')+'</p>';
        html += '</div>';
    }
    // Latest Request per Endpoint
    if (row.data.endpoints === null) {
        return "";
    }
    html += '<h4>'+__('Latest Request per Endpoint')+'</h4>';
    html += '<table class="table table-hover table-striped text-nowrap">';
    html += '<thead>';
    html += '<tr>';
    html += '<td class="col-md-1">'+__('Status')+'</td>';
    html += '<td class="col-md-2">'+__('Endpoint')+'</td>';
    html += '<td>'+__('Created At')+'</td>';
    html += '</tr>';
    html += '</thead>';
    html += '<tbody>';
    $.each(row.data.endpoints, function(k, v) {
        html += '<tr>';
        html += '<td>'+healthCheckStatusFormatter(v.status)+'</td>';
        html += '<td>'+v.endpoint+'</td>';
        html += '<td>'+v.created_at+'</td>';
        html += '</tr>';
    });
    html += '</tbody>';
    html += '</table>';
    return html;
}

/**
 * Health Check Detail C sence Booking Feeds API (REST).
 * @param {Object} row
 */
function healthCheckDetailCsenceBookingFeedsApiRest(row) {
    let html = "";
    if (row.status === "OK") {
        html += '<div class="alert alert-info" role="alert">';
        html += '<p>'+__('Requests have been received in the past :hours hours.').replace(':hours', row.data.hours)+'</p>';
        html += '</div>';
    }
    if (row.status === "FAILED") {
        html += '<div class="alert alert-danger" role="alert">';
        html += '<p>'+__('An error has occurred.')+'</p>';
        html += '</div>';
    }
    if (row.status === "WARNING") {
        html += '<div class="alert alert-warning" role="alert">';
        html += '<p>'+__('No requests have been received in the past :hours hours.').replace(':hours', row.data.hours)+'</p>';
        html += '</div>';
    }
    if (row.data.last_request.created_at === null) {
        return "";
    }
    html += '<h4>'+__('Last Request')+'</h4>';
    html += '<table class="table table-hover table-striped text-nowrap">';
    html += '<thead>';
    html += '<tr>';
    html += '<td class="col-md-2">'+__('Created At')+'</td>';
    html += '<td class="col-md-2">'+__('IP-Address')+'</td>';
    html += '<td>'+__('Hostname')+'</td>';
    html += '<td>&nbsp;</td>';
    html += '</tr>';
    html += '</thead>';
    html += '<tbody>';
    html += '<tr>';
    html += '<td>'+row.data.last_request.created_at+'</td>';
    html += '<td>'+row.data.last_request.ip_address+'</td>';
    html += '<td>'+row.data.last_request.hostname+'</td>';
    if (row.data.last_request.error_description !== null) {
        html += '<td style="background-color: #F2D4CE !important; color: #AE432E !important">';
        html += row.data.last_request.error_description;
        html += '</td>';
    } else {
        html += '<td>&nbsp;</td>';
    }
    html += '</tr>';
    html += '</tbody>';
    html += '</table>';
    // Latest Request per Client
    if (row.data.clients === null) {
        return "";
    }
    html += '<h4>'+__('Latest Request per Client')+'</h4>';
    html += '<table class="table table-hover table-striped text-nowrap">';
    html += '<thead>';
    html += '<tr>';
    html += '<td class="col-md-1">'+__('Status')+'</td>';
    html += '<td class="col-md-2">'+__('Name')+'</td>';
    html += '<td class="col-md-2">'+__('Client ID')+'</td>';
    html += '<td class="col-md-2">'+__('Created At')+'</td>';
    html += '<td class="col-md-2">'+__('IP-Address')+'</td>';
    html += '<td>'+__('Hostname')+'</td>';
    html += '<td>&nbsp;</td>';
    html += '</tr>';
    html += '</thead>';
    html += '<tbody>';
    $.each(row.data.clients, function(k, v) {
        html += '<tr>';
        html += '<td>'+healthCheckStatusFormatter(v.status)+'</td>';
        html += '<td>'+v.name+'</td>';
        html += '<td>'+v.client_id+'</td>';
        html += '<td>'+(v.last_request !== null ? v.last_request.created_at : '-')+'</td>';
        html += '<td>'+(v.last_request !== null ? v.last_request.ip_address : '-')+'</td>';
        html += '<td>'+(v.last_request !== null ? v.last_request.hostname : '-')+'</td>';
        if (v.last_request !== null && v.last_request.error_description !== null && typeof v.last_request.error_description !== "undefined") {
            html += '<td style="background-color: #F2D4CE !important; color: #AE432E !important">';
            html += v.last_request.error_description;
            html += '</td>';
        } else {
            html += '<td>&nbsp;</td>';
        }
        html += '</tr>';
    });
    html += '</tbody>';
    html += '</table>';
    return html;
}

/**
 * Health Check Detail C sence Temperatures API (REST).
 * @param {Object} row
 */
function healthCheckDetailCsenceTemperaturesApiRest(row) {
    let html = "";
    if (row.status === "OK") {
        html += '<div class="alert alert-info" role="alert">';
        html += '<p>'+__('Requests have been received in the past :hours hours.').replace(':hours', row.data.hours)+'</p>';
        html += '</div>';
    }
    if (row.status === "FAILED") {
        html += '<div class="alert alert-danger" role="alert">';
        html += '<p>'+__('An error has occurred.')+'</p>';
        html += '</div>';
    }
    if (row.status === "WARNING") {
        html += '<div class="alert alert-warning" role="alert">';
        html += '<p>'+__('No requests have been received in the past :hours hours.').replace(':hours', row.data.hours)+'</p>';
        html += '</div>';
    }
    if (row.status === "INFO") {
        html += '<div class="alert alert-info" role="alert">';
        html += '<p>'+__('No requests have been received in the past :hours hours.').replace(':hours', row.data.hours)+'</p>';
        html += '</div>';
    }
    if (row.data.last_request.created_at === null) {
        return "";
    }
    html += '<h4>'+__('Last Request')+'</h4>';
    html += '<table class="table table-hover table-striped text-nowrap">';
    html += '<thead>';
    html += '<tr>';
    html += '<td class="col-md-2">'+__('Created At')+'</td>';
    html += '<td class="col-md-2">'+__('IP-Address')+'</td>';
    html += '<td>'+__('Hostname')+'</td>';
    html += '<td>&nbsp;</td>';
    html += '</tr>';
    html += '</thead>';
    html += '<tbody>';
    html += '<tr>';
    html += '<td>'+row.data.last_request.created_at+'</td>';
    html += '<td>'+row.data.last_request.ip_address+'</td>';
    html += '<td>'+row.data.last_request.hostname+'</td>';
    if (row.data.last_request.error_description !== null) {
        html += '<td style="background-color: #F2D4CE !important; color: #AE432E !important">';
        html += row.data.last_request.error_description;
        html += '</td>';
    } else {
        html += '<td>&nbsp;</td>';
    }
    html += '</tr>';
    html += '</tbody>';
    html += '</table>';
    // Latest Request per Client
    if (row.data.clients === null) {
        return "";
    }
    html += '<h4>'+__('Latest Request per Client')+'</h4>';
    html += '<table class="table table-hover table-striped text-nowrap">';
    html += '<thead>';
    html += '<tr>';
    html += '<td class="col-md-1">'+__('Status')+'</td>';
    html += '<td class="col-md-2">'+__('Name')+'</td>';
    html += '<td class="col-md-2">'+__('Client ID')+'</td>';
    html += '<td class="col-md-2">'+__('Created At')+'</td>';
    html += '<td class="col-md-2">'+__('IP-Address')+'</td>';
    html += '<td>'+__('Hostname')+'</td>';
    html += '<td>&nbsp;</td>';
    html += '</tr>';
    html += '</thead>';
    html += '<tbody>';
    $.each(row.data.clients, function(k, v) {
        html += '<tr>';
        html += '<td>'+healthCheckStatusFormatter(v.status)+'</td>';
        html += '<td>'+v.name+'</td>';
        html += '<td>'+v.client_id+'</td>';
        html += '<td>'+(v.last_request !== null ? v.last_request.created_at : '-')+'</td>';
        html += '<td>'+(v.last_request !== null ? v.last_request.ip_address : '-')+'</td>';
        html += '<td>'+(v.last_request !== null ? v.last_request.hostname : '-')+'</td>';
        if (v.last_request !== null && v.last_request.error_description !== null && typeof v.last_request.error_description !== "undefined") {
            html += '<td style="background-color: #F2D4CE !important; color: #AE432E !important">';
            html += v.last_request.error_description;
            html += '</td>';
        } else {
            html += '<td>&nbsp;</td>';
        }
        html += '</tr>';
    });
    html += '</tbody>';
    html += '</table>';
    return html;
}

/**
 * Health Check Detail C sence Energy API (REST).
 * @param {Object} row
 */
function healthCheckDetailCsenceEnergyApiRest(row) {
    let html = "";
    if (row.status === "OK") {
        html += '<div class="alert alert-info" role="alert">';
        html += '<p>'+__('Requests have been received in the past :hours hours.').replace(':hours', row.data.hours)+'</p>';
        html += '</div>';
    }
    if (row.status === "FAILED") {
        html += '<div class="alert alert-danger" role="alert">';
        html += '<p>'+__('An error has occurred.')+'</p>';
        html += '</div>';
    }
    if (row.status === "WARNING") {
        html += '<div class="alert alert-warning" role="alert">';
        html += '<p>'+__('No requests have been received in the past :hours hours.').replace(':hours', row.data.hours)+'</p>';
        html += '</div>';
    }
    if (row.status === "INFO") {
        html += '<div class="alert alert-info" role="alert">';
        html += '<p>'+__('No requests have been received in the past :hours hours.').replace(':hours', row.data.hours)+'</p>';
        html += '</div>';
    }
    if (row.data.last_request.created_at === null) {
        return "";
    }
    html += '<h4>'+__('Last Request')+'</h4>';
    html += '<table class="table table-hover table-striped text-nowrap">';
    html += '<thead>';
    html += '<tr>';
    html += '<td class="col-md-2">'+__('Created At')+'</td>';
    html += '<td class="col-md-2">'+__('IP-Address')+'</td>';
    html += '<td>'+__('Hostname')+'</td>';
    html += '<td>&nbsp;</td>';
    html += '</tr>';
    html += '</thead>';
    html += '<tbody>';
    html += '<tr>';
    html += '<td>'+row.data.last_request.created_at+'</td>';
    html += '<td>'+row.data.last_request.ip_address+'</td>';
    html += '<td>'+row.data.last_request.hostname+'</td>';
    if (row.data.last_request.error_description !== null) {
        html += '<td style="background-color: #F2D4CE !important; color: #AE432E !important">';
        html += row.data.last_request.error_description;
        html += '</td>';
    } else {
        html += '<td>&nbsp;</td>';
    }
    html += '</tr>';
    html += '</tbody>';
    html += '</table>';
    // Latest Request per Client
    if (row.data.clients === null) {
        return "";
    }
    html += '<h4>'+__('Latest Request per Client')+'</h4>';
    html += '<table class="table table-hover table-striped text-nowrap">';
    html += '<thead>';
    html += '<tr>';
    html += '<td class="col-md-1">'+__('Status')+'</td>';
    html += '<td class="col-md-2">'+__('Name')+'</td>';
    html += '<td class="col-md-2">'+__('Client ID')+'</td>';
    html += '<td class="col-md-2">'+__('Created At')+'</td>';
    html += '<td class="col-md-2">'+__('IP-Address')+'</td>';
    html += '<td>'+__('Hostname')+'</td>';
    html += '<td>&nbsp;</td>';
    html += '</tr>';
    html += '</thead>';
    html += '<tbody>';
    $.each(row.data.clients, function(k, v) {
        html += '<tr>';
        html += '<td>'+healthCheckStatusFormatter(v.status)+'</td>';
        html += '<td>'+v.name+'</td>';
        html += '<td>'+v.client_id+'</td>';
        html += '<td>'+(v.last_request !== null ? v.last_request.created_at : '-')+'</td>';
        html += '<td>'+(v.last_request !== null ? v.last_request.ip_address : '-')+'</td>';
        html += '<td>'+(v.last_request !== null ? v.last_request.hostname : '-')+'</td>';
        if (v.last_request !== null && v.last_request.error_description !== null && typeof v.last_request.error_description !== "undefined") {
            html += '<td style="background-color: #F2D4CE !important; color: #AE432E !important">';
            html += v.last_request.error_description;
            html += '</td>';
        } else {
            html += '<td>&nbsp;</td>';
        }
        html += '</tr>';
    });
    html += '</tbody>';
    html += '</table>';
    return html;
}
